var _defs, _g, _path, _rect, _rect2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    role: "img",
    "aria-label": "InstantTranscriber icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "it_grad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6D5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "it_shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 6,
    stdDeviation: 6,
    floodColor: "#0B102A",
    floodOpacity: 0.12
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#it_shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 96,
    height: 96,
    rx: 24,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 94.5,
    height: 94.5,
    rx: 23.25,
    stroke: "#E9ECF5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 46 C18 29.984 31.984 16 48 16 C64.016 16 78 29.984 78 46",
    stroke: "url(#it_grad)",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 46,
    width: 16,
    height: 26,
    rx: 8,
    fill: "url(#it_grad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 46,
    width: 16,
    height: 26,
    rx: 8,
    fill: "url(#it_grad)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25,38)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22,
    width: 6,
    height: 20,
    rx: 3,
    fill: "url(#it_grad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 6,
    height: 28,
    rx: 3,
    fill: "url(#it_grad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6,
    width: 6,
    height: 36,
    rx: 3,
    fill: "url(#it_grad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 14,
    width: 6,
    height: 28,
    rx: 3,
    fill: "url(#it_grad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 22,
    width: 6,
    height: 20,
    rx: 3,
    fill: "url(#it_grad)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d2c3aa70c35a11b4ce4fc79cc0f652e0.svg";
export { ForwardRef as ReactComponent };